export const GET_SHIPMENT_REQUEST = 'GET_SHIPMENT_REQUEST';
export const GET_SHIPMENT_SUCCESS = 'GET_SHIPMENT_SUCCESS';
export const GET_SHIPMENT_ERROR = 'GET_SHIPMENT_ERROR';

export const ADD_SHIPMENT_REQUEST = 'ADD_SHIPMENT_REQUEST';
export const ADD_SHIPMENT_SUCCESS = 'ADD_SHIPMENT_SUCCESS';
export const ADD_SHIPMENT_ERROR = 'ADD_SHIPMENT_ERROR';

export const UPDATE_SHIPMENT_REQUEST = 'UPDATE_SHIPMENT_REQUEST';
export const UPDATE_SHIPMENT_SUCCESS = 'UPDATE_SHIPMENT_SUCCESS';
export const UPDATE_SHIPMENT_ERROR = 'UPDATE_SHIPMENT_ERROR';

export const DELETE_SHIPMENT_REQUEST = 'DELETE_SHIPMENT_REQUEST';
export const DELETE_SHIPMENT_SUCCESS = 'DELETE_SHIPMENT_SUCCESS';
export const DELETE_SHIPMENT_ERROR = 'DELETE_SHIPMENT_ERROR'; 